var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-alert',{staticClass:"mx-auto col-6",attrs:{"type":"warning","justify":"center"}},[_vm._v(" Esta página no es accesible directamente ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }